import React from 'react';
import { CaregivingHeartIcon } from './caregiving-heart-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';
import caregivingPersonImage from './caregiving-person.webp';

interface CaregivingTopicCardProps {
  title: string;
  className?: string;
}

export const CaregivingTopicCard: React.FC<CaregivingTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute -left-2 top-2 h-[60px] w-[61px] shrink-0 sm:-left-2 sm:top-4 sm:h-[90px] sm:w-[92.14px]">
          <CaregivingHeartIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={caregivingPersonImage}
          alt=""
          className="relative z-10 ml-6 aspect-[157.04/142.12] w-[105px] shrink-0 object-cover object-center sm:ml-8 sm:w-[157.038px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
